import { render, staticRenderFns } from "./MultilistSelector.vue?vue&type=template&id=67edfa3e&scoped=true"
import script from "./MultilistSelector.vue?vue&type=script&lang=js"
export * from "./MultilistSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67edfa3e",
  null
  
)

export default component.exports